import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {JhiLanguageService} from 'app/ng-jhipster/language';
import {JhiLanguageHelper} from 'app/core/language/language.helper';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'plant',
        loadChildren: () => import('./plant/plant.module').then(m => m.FinitoPlantModule)
      },
      {
        path: 'model-year',
        loadChildren: () => import('./model-year/model-year.module').then(m => m.FinitoModelYearModule)
      },
      {
        path: 'model-e',
        loadChildren: () => import('./model-e/model-e.module').then(m => m.FinitoModelEModule)
      },
      {
        path: 'type-e',
        loadChildren: () => import('./type-e/type-e.module').then(m => m.FinitoTypeEModule)
      },
      {
        path: 'c-nr-vds-type-code',
        loadChildren: () => import('./c-nr-vds-type-code/c-nr-vds-type-code.module').then(m => m.FinitoCNrVdsTypeCodeModule)
      },
      {
        path: 'c-nr-vds-type-code-exception',
        loadChildren: () =>
          import('./c-nr-vds-type-code-exception/c-nr-vds-type-code-exception.module').then(m => m.FinitoCNrVdsTypeCodeExceptionModule)
      },
      {
        path: 'eu-check-digit',
        loadChildren: () => import('./eu-check-digit/eu-check-digit.module').then(m => m.EuCheckDigitModule)
      },
      {
        path: 'body-planing',
        loadChildren: () => import('./body-planing/body-planing.module').then(m => m.FinitoBodyPlaningModule)
      },
      {
        path: 'body-planing-data',
        loadChildren: () => import('./body-planing-data/body-planing-data.module').then(m => m.FinitoBodyPlaningDataModule)
      },
      {
        path: 'management-tasks',
        loadChildren: () => import('./management-tasks/management-tasks.module').then(m => m.FinitoManagementTasksModule)
      },
      {
        path: 'search/vehicle',
        loadChildren: () => import('./search-vehicle/search-vehicle.module').then(m => m.SearchVehicleModule)
      },
      {
        path: 'search/vehicle-multiple',
        loadChildren: () => import('./search-vehicle-multiple/search-vehicle-multiple.module').then(m => m.SearchVehicleMultipleModule)
      },
      {
        path: 'search/archived-vehicle',
        loadChildren: () => import('./search-archived-vehicle/search-archived-vehicle.module').then(m => m.SearchArchivedVehicleModule)
      },
      {
        path: 'lock-vin',
        loadChildren: () => import('./lock-vin/lock-vin.module').then(m => m.LockVinModule)
      },
      {
        path: 'reserve-vin',
        loadChildren: () => import('./reserve-vin/reserve-vin.module').then(m => m.ReserveVinModule)
      },
      {
        path: 'manual-vin-adjustment',
        loadChildren: () => import('./manual-vin-adjustment/manual-vin-adjustment.module').then(m => m.ManualVinAdjustmentModule)
      },
      {
        path: 'monitoring',
        loadChildren: () => import('./monitoring/monitoring.module').then(m => m.FinitoMonitoringModule)
      },
      {
        path: 'planing-circle-data',
        loadChildren: () => import('./planing-circle-data/planing-circle-data.module').then(m => m.FinitoPlaningCircleDataModule)
      }
      /* jhipster-needle-add-entity-route - JHipster will add entity modules routes here */
    ])
  ],
  providers: [{ provide: JhiLanguageService, useClass: JhiLanguageService }]
})
export class FinitoEntityModule {
  constructor(private languageService: JhiLanguageService, private languageHelper: JhiLanguageHelper) {
    this.languageHelper.language.subscribe((languageKey: string) => {
      if (languageKey !== undefined) {
        this.languageService.changeLanguage(languageKey);
      }
    });
  }
}
